import script from "./IntroPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./IntroPage.vue?vue&type=script&lang=ts&setup=true"

import "./IntroPage.vue?vue&type=style&index=0&id=4c9d920e&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9d920e"]])

export default __exports__